// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import ContactUsForm from "@mcmc/App/Components/ContactUsForm/ContactUsForm";
import mergeToNew from "@mcmc/XDL/Utilities/xMergeToNew";
import React, { useState } from "react";

interface OwnProps {
    labelOverride?: string;
    warehouse?: string;
    variant?: string;
    extendedStyles?: ContactUsButtonStyles;
}

type Props = OwnProps;

export interface ContactUsButtonStyles {
    modal?: ModalPresentationProps;
    contactUsButton?: ButtonPresentationProps;
    contactUsLink?: LinkPresentationProps;
}

export const contactUsButtonStyles: ContactUsButtonStyles = {
    modal: {
        size: 500,
        cssOverrides: {},
    },
    contactUsButton: {
        variant: "secondary",
        sizeVariant: "medium",
    },
};

const ContactUsButton = ({ labelOverride, warehouse, variant = "button", extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(contactUsButtonStyles, extendedStyles));
    const contactUsPardotUrl = useAppSelector(
        state => (getSettingsCollection(state).customSettings as any)?.contactUsPardotUrl,
    );

    const [modalIsOpen, setModalIsOpen] = React.useState(false);

    const contactUsClickHandler = () => {
        setModalIsOpen(true);
    };

    const modalCloseHandler = () => {
        setModalIsOpen(false);
    };

    const formOnSuccess = () => {
        modalCloseHandler();
    };

    return (
        <>
            {variant === "button" && (
                <Button {...styles.contactUsButton} onClick={contactUsClickHandler} id="contactusra">
                    {labelOverride || translate("Contact")}
                </Button>
            )}
            {variant === "link" && (
                <Link {...styles.contactUsLink} onClick={contactUsClickHandler} id="contactusra">
                    {labelOverride || translate("Contact")}
                </Link>
            )}
            <Modal
                {...styles.modal}
                headline={translate("Contact Us")}
                isOpen={modalIsOpen}
                handleClose={modalCloseHandler}
            >
                <ContactUsForm formUrl={contactUsPardotUrl} />
            </Modal>
        </>
    );
};

export default ContactUsButton;
